// src/components/ProtectedRoute.js
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { usePermissions } from "../context/PermissionContext";
import MasterLayout from "../masterLayout/MasterLayout";
import LoadingComponent from "./ui/LoadingComponent";

export const routePermissions = {
  // Billings
  "/tax-types": "view_tax_types",
  "/tax-rates": "view_tax_rates",
  "/view_billing_summary": "view_billing_summary",
  // Clients
  "/all-clients": "view_client",
  "/add-client": "insert_client",
  "/view-client/:id": "view_client", // only one used
  "/view-client/:clientId": "view_client", // only one used
  "/view-client/:clientId": "view_client", // only one used
  "/update-client/:clientId": "update_client",
  "/client-branches": "view_client_branches",
  "/branch-location": "view_branch_location",
  "/client-roles": "view_client_roles",
  "/staff": "view_staff",
  "/customer-profile": "view_customer_profile",
  "/client-permissions": "view_client_permission",
  "/client-management": "view_client_management",
  // Geographical
  "/all-countries": "view_countries",
  "/all-cities": "view_cities",
  "/add-country": "insert_countries",
  "/edit-country/:ID": "update_countries",

  // Vehicle Master Data
  "/vehicle-types": "view_vehicle_types",
  "/vehicle-makes": "view_vehicle_makes",
  "/vehicle-models": "view_vehicle_models",
  "/plate-authorities": "view_plate_authority",
  // WorkFlow
  "/workflow-list": "view_workflow",
  "/edit-work-flow": "insert_workflow",
  "/workflow-assign": "view_assign_workflow",
  "/assign-workflow": "assign_workflow",
  "/workflows-suggestions": "view_workflow_suggestion_step",
  "/workflows-steps/:ID": "insert_workflow_suggestion_step",
  // Planning
  "/all-plans": "view_plan",
  "/add-plan": "insert_plan",
  "/update-plan/:plan_id": "update_plan",
  // Users
  "/add-user-permission": "insert_permission",
  "/all-roles": "view_roles",
  "/all-users": "view_user",
  "/add-user": "insert_user",
  "/edit-user/:userId": "update_user",
  "/user-permissions": "view_user_permission",
  "/assign-permissions": "assign_user_permission",
};

const ProtectedRoute = () => {
  const { isAuthenticated, hasPermission, isLoading } = usePermissions();
  const location = useLocation();
  const currentPath = location.pathname;

  if (isLoading) {
    return <LoadingComponent />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/sign-in" state={{ from: location }} replace />;
  }

  if (currentPath === "/") {
    return (
      <MasterLayout>
        <Outlet />
      </MasterLayout>
    );
  }

  const requiredPermission = Object.keys(routePermissions).find((route) => {
    const routePattern = route.replace(/:[^/]+/, "[^/]+");
    const regex = new RegExp(`^${routePattern}$`);
    return regex.test(currentPath);
  });

  if (
    requiredPermission &&
    !hasPermission(routePermissions[requiredPermission])
  ) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  return (
    <MasterLayout>
      <Outlet />
    </MasterLayout>
  );
};

export default ProtectedRoute;
